// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../node_modules/css-loader/index.js??ref--7-2!./wangEditor.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../node_modules/vue-style-loader/lib/addStylesClient.js")("648ff7da", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/vendor/wangEditorV2/css/wangEditor.css
// module id = 3550
// module chunks = 6